// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","environmentBadge":"App_environmentBadge__qTZwm","content":"App_content__naSmy"};